// Tenantra Inc. - Hero visual: monthly rent ledger that fills in and flips to "Reported to Equifax"
import { useEffect, useState } from 'react';
import { CheckCircle2, FileSignature } from 'lucide-react';

const ROWS = [
  { month: 'Jan 2026', paid: '01 Jan' },
  { month: 'Feb 2026', paid: '01 Feb' },
  { month: 'Mar 2026', paid: '01 Mar' },
  { month: 'Apr 2026', paid: '01 Apr' },
  { month: 'May 2026', paid: '01 May' },
  { month: 'Jun 2026', paid: '01 Jun' },
];

export const RentLedgerCard = ({ start = true }) => {
  const [filled, setFilled] = useState(0);
  const [reported, setReported] = useState(0);

  useEffect(() => {
    if (!start) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { setFilled(ROWS.length); setReported(ROWS.length); return; }
    const timers = [];
    ROWS.forEach((_, i) => {
      timers.push(setTimeout(() => setFilled(i + 1), 500 + i * 160));
      timers.push(setTimeout(() => setReported(i + 1), 1100 + i * 160));
    });
    return () => timers.forEach(clearTimeout);
  }, [start]);

  return (
    <div className="bg-white border border-stone-200 rounded-lg overflow-hidden" data-testid="hero-rent-ledger">
      <div className="flex items-start justify-between px-5 py-4 border-b border-stone-200">
        <div>
          <p className="text-xs text-stone-500 mb-1">Rent record TNT-100200</p>
          <p className="text-sm font-semibold text-stone-900">E. Tremblay</p>
          <p className="text-xs text-stone-500">88 Harbour St, Unit 2104 · Toronto ON</p>
        </div>
        <div className="text-right">
          <p className="text-xs text-stone-500 mb-1">Monthly rent</p>
          <p className="text-sm font-semibold text-stone-900 tabular-nums">$2,450.00</p>
        </div>
      </div>

      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs text-stone-500 border-b border-stone-200">
            <th className="font-medium px-5 py-2">Month</th>
            <th className="font-medium px-3 py-2">Paid</th>
            <th className="font-medium px-3 py-2">Status</th>
            <th className="font-medium px-5 py-2 text-right">Equifax</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r, i) => {
            const show = i < filled;
            const rep = i < reported;
            return (
              <tr key={r.month} className={`border-b border-stone-100 transition-opacity duration-300 ${show ? 'opacity-100' : 'opacity-0'}`} data-testid={`ledger-row-${i}`}>
                <td className="px-5 py-2.5 text-stone-800">{r.month}</td>
                <td className="px-3 py-2.5 text-stone-600 tabular-nums">{r.paid}</td>
                <td className="px-3 py-2.5">
                  <span className="inline-flex items-center gap-1.5 text-teal-800 text-xs font-medium">
                    <CheckCircle2 className="w-3.5 h-3.5 text-teal-600" strokeWidth={2} /> On time
                  </span>
                </td>
                <td className="px-5 py-2.5 text-right">
                  <span className={`text-xs font-medium transition-colors duration-300 ${rep ? 'text-teal-700' : 'text-stone-400'}`}>
                    {rep ? 'Reported' : 'Pending'}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="flex items-center gap-2.5 px-5 py-3 bg-stone-50 text-xs text-stone-600" data-testid="ledger-consent-footer">
        <FileSignature className="w-4 h-4 text-stone-500" strokeWidth={1.75} />
        <span>Reporting consent e-signed by tenant on Dec 28, 2025. Can be withdrawn anytime.</span>
      </div>
    </div>
  );
};
